import { render, staticRenderFns } from "./ImageGalleryImage.vue?vue&type=template&id=5bc56ae0"
import script from "./ImageGalleryImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageGalleryImage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports